import React, { useState, useEffect } from 'react';
import { Tree } from 'antd';
import { flattenDeep } from 'lodash';
import { connect } from 'react-redux';
import { getTreeData } from './apicalls';
import { bindActionCreators } from 'redux';
import { DownloadOutlined } from '@ant-design/icons';
import localStorage from '../../../../../utils/localStorage';
import { useNavigate } from 'react-router-dom';
import LayoutAction from '../../../../../modules/actions/LayoutAction';

const { TreeNode } = Tree;

const LeftSidePanel = (props) => {
  const [treeData, setTreeData] = useState([]);
  const [expandKey, setExpandKey] = useState([]);
  // const [autoExpandParent, setAutoExpandParent] = useState(false);
  // const [searchValue, setSearchValue] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    assetHierarchy();
  }, []);

  const assetHierarchy = async () => {
    const treeData = await getTreeData();
    const expandKey = await getAllKeys(treeData);
    setTreeData(treeData);
    setExpandKey(expandKey);
  };

  const getAllKeys = (data) => {
    const nestedKeys = data.map((node) => {
      let childKeys = [];
      if (node.children) {
        childKeys = getAllKeys(node.children);
      }
      return [childKeys, node.key];
    });
    return flattenDeep(nestedKeys);
  };

  const getData = (item) => {
    let { Type, Name, Code } = item;
    const siteId = localStorage.get('currentSite');
    if (Type === 'Device') {
      navigate({
        pathname: `/rubus/dashboard/Renewable Energy`,
        state: { DeviceCode: `${siteId}_${Code}`, DeviceName: Name }
      });
    } else {
      props.onTreeSelect(Type, Code, Name);
    }
  };

  const renderTreeNodes = (data) => {
    return data.map((item) => {
      if (item.children && item.children.length > 0) {
        return (
          <TreeNode
            title={<div onClick={() => getData(item)}>{item.Name}</div>}
            key={item.key}
            dataRef={item}
          >
            {renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return (
        <TreeNode
          key={item.key}
          title={<div onClick={() => getData(item)}>{item.Name}</div>}
          dataRef={item}
        />
      );
    });
  };

  return (
    <>
      <div style={{ minHeight: window.innerHeight - 73, borderRight: '1px dashed black' }}>
        <Tree
          showLine
          defaultExpandAll={true}
          switcherIcon={<DownloadOutlined />}
          onSelect={props.onTreeSelect}
          expandedKeys={expandKey}
        >
          {renderTreeNodes(treeData)}
        </Tree>
      </div>
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  LayoutAction: bindActionCreators(LayoutAction, dispatch),
});

export default connect(mapDispatchToProps)(LeftSidePanel);
